module.exports = __webpack_public_path__ + "static/img/tx_gr.6552637.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/team/tx_gr.png
// module id = 4gs6
// module chunks = 0